/* eslint-disable no-nested-ternary */
/* eslint-disable no-prototype-builtins */
import React, { Component } from 'react';
import { injectIntl, FormattedHTMLMessage, FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import utils from 'shared/helpers/utils';
// import { CLIENT_CLASSIFICATION } from 'shared/constant';
import { stepAction, applicantAction, agreementAction } from 'shared/store/actions';
import { LayoutWithNavbar } from 'layouts';
import selectors from 'shared/store/selectors';
import { Modal, PageContentWrapper } from 'components';
import {
  isMobileOnly,
  isMobileSafari, isIOS,
} from 'react-device-detect';
import { Banner, Step } from './components';
import './Home.scss';

const statusBarClass = 'status-bar--blue';
class Home extends Component {
  state = {
    showWelcom: false,
    showNotification: false,
  };

  componentDidMount() {
    const {
      intl, onUpdateSteps,
      applicantId,
      // onGetApplicantDetails,
      formSignature,
      // clientClassification,
      onGetAgreementStatus,
    } = this.props;

    /** Update Stepper status */
    if (applicantId) onUpdateSteps(intl);
    // onGetApplicantDetails();
    this.setState({ showWelcom: true });
    if (isMobileOnly) {
      document.body.classList.add(statusBarClass);
    }

    /** @todo add this condition: '&& clientClassification === CLIENT_CLASSIFICATION.QUALIFIED' on Dec 31 2023 to support for now the retail client  */
    if (formSignature) onGetAgreementStatus();
  }

  componentWillUnmount() {
    if (isMobileOnly) {
      document.body.classList.remove(statusBarClass);
    }
  }

  /**
   * Warning popup ok/close button
   * warning for client with no refCode
   */
  onHandleOk = () => {
    const { onLogout } = this.props;
    onLogout().then(() => {
      /** have to add this condition for iOS redirection to work */
      if (isIOS || isMobileSafari) {
        window.location.assign(process.env.REACT_APP_MAIN_WRAPPER);
      } else {
        window.open(process.env.REACT_APP_MAIN_WRAPPER, '_self');
      }
    });
    this.setState({ showNotification: false });
  }

  render() {
    const {
      steps, history, onResetApplication, clientName, refCode, isAllStepsCompleted,
      completionDate, lastLoggedIn, isFirstAgreementCompleted, currentStep, intl,
    } = this.props;
    const { showWelcom, showNotification } = this.state;
    // const isAllCompleted = isEmailSent;
    // const isAllCompleted = steps.filter(item => item.hasOwnProperty('isCompleted') && item.isCompleted).length;
    // console.log('isAllCompleted', isAllCompleted, isAllCompleted >= 5);
    // console.log('ALL steps completed ', isAllStepsCompleted, completionDate);
    const renderWelcomeMsg = () => {
      let renderMsg; // = refCode ? <FormattedHTMLMessage id="welcome.firstVisitWithRefCode" values={{ refCode }} /> : <FormattedHTMLMessage id="welcome.firstVisit" />;
      if (isAllStepsCompleted && completionDate) {
        renderMsg = <FormattedHTMLMessage id="welcome.completed" values={{ name: clientName, date: utils.convertUnixDateToStandard(completionDate) }} />;
      } else {
        renderMsg = lastLoggedIn === null
          ? (refCode ? <FormattedHTMLMessage id="welcome.firstVisitWithRefCode" values={{ refCode }} /> : <FormattedHTMLMessage id="welcome.firstVisit" />)
          : (refCode ? <FormattedHTMLMessage id="welcome.inCompleteWithRefCode" values={{ refCode, name: clientName }} /> : <FormattedHTMLMessage id="welcome.inComplete" values={{ name: clientName }} />);
      }
      return renderMsg;
    };
    const modalContent = <div className="welcome-message">{renderWelcomeMsg()}</div>;
    return (
      <>
        <div className="homepage">
          <Banner
            intro={intl.formatMessage({ id: 'welcome.requiredToComplete' })}
            onDoubleClick={() => onResetApplication()}
            msg={renderWelcomeMsg()}
          />

          <PageContentWrapper>
            {steps && steps.map((item, idx) => (
              <Step
                key={`step-${idx}`}
                isTranslate={false}
                onStepClick={() => history.push(item.pageSource)}
                {...item}
                isAllCompleted={isFirstAgreementCompleted} // isAllStepsCompleted
                currentStep={currentStep}
              />
            ))}
            {isMobileOnly && (
            <Modal withPadding showModal={showWelcom} onClose={() => this.setState({ showWelcom: false })}>
              {modalContent}
            </Modal>
            )}

            {/* SHOW WARNING NOTIFICATION IF NO REFCODE, TO REDIRECT USER BACK TO IMARKAZ */}
            {showNotification && !refCode && (
              <Modal withPadding isWarning showModal={showNotification} onClose={() => this.onHandleOk()}>
                <>
                  <p><FormattedMessage id="warning.msg1" /></p>
                  <p><FormattedMessage id="warning.msg2" /></p>
                  <p><FormattedHTMLMessage id="warning.msg3" /></p>
                  <p><FormattedHTMLMessage id="warning.msg4" /></p>
                </>
              </Modal>
            )}
          </PageContentWrapper>
        </div>


      </>
    );
  }
}

const mapStateToProps = state => ({
  steps: state.stepsReducer.steps,
  currentStep: state.stepsReducer.currentStep,
  clientPhoneNumber: selectors.getPhoneNumber(state),
  token: selectors.getToken(state),
  applicantId: selectors.getApplicantId(state),
  isEmailSent: selectors.getApplicantIsEmailSent(state),
  clientName: selectors.getFullName(state),
  isIdPassportCompleted: selectors.isIdPassportCompleted(state),
  refCode: selectors.getRefCode(state),
  isAllStepsCompleted: selectors.isAllStepsCompleted(state),
  completionDate: selectors.getCompletionDate(state),
  lastLoggedIn: selectors.getLastLoggedIn(state),
  currentLoggedIn: selectors.getCurrentLoggedIn(state),
  formSignature: selectors.getAofKycProfileSignature(state),
  clientClassification: selectors.getClientClassification(state),
  isFirstAgreementCompleted: selectors.isFirstAgreementCompleted(state),
});

const mapDispatchToProps = dispatch => ({
  onUpdateSteps: intl => dispatch(stepAction.updateSteps(intl)),
  onGetStepsProgress: () => dispatch(stepAction.getProgress()),
  onCreateApplicant: () => dispatch(applicantAction.createApplicant()),
  onResetApplication: () => dispatch(applicantAction.resetApplication()),
  onGetApplicantDetails: () => dispatch(applicantAction.getApplicantDetails()),
  onGetAgreementStatus: () => dispatch(agreementAction.getQualifiedAgreementStatus()),
});

export default connect(mapStateToProps, mapDispatchToProps)(LayoutWithNavbar(injectIntl(Home)));
